import React, {Component} from 'react'
import propTypes from 'prop-types'
import {SelectField} from 'components/selectField'
import {api} from 'services/api'
import {
  getColorForDeliveryNoteStatus,
  getDeliveryNoteOption,
  getDeliveryNoteStatusName,
} from 'helpers/deliveries/deliveryNotes'
import './deliveryNoteSelectField.scss'
import {get, isEqual, isNil} from 'lodash'
import themeVars from 'theme/themeVars'
import {prefix} from "helpers/component"
import DateComponent from 'containers/date'

const getClassName = prefix('deliveryNoteSelectField-')

class DeliveryNoteSelectField extends Component {
  constructor(props) {
    super(props)
    this.state = {
      deliveryNotes: [],
    }
  }

  componentDidMount = async () => {
    await this.onLoadDeliveryNotes()
  }

  componentDidUpdate = async (prevProps) => {
    const {orderId} = this.props
    if (!isEqual(prevProps.orderId, orderId))
      await this.onLoadDeliveryNotes()
  }

  onLoadDeliveryNotes = async () => {
    const {excludeLinkedToDelivery, excludeReturnNotes, orderId, status} = this.props

    const fields = {
      default: true,
      order: {
        id: true,
        orderItems: true,
      },
      deliveryNoteItems: true,
      hasDeliveries: true,
    }
    const params = {
      excludeLinkedToDelivery,
      excludeReturnNotes,
      orderId,
    }
    if (!isNil(status)) {
      params.status = status
    }

    await api.deliveryNote.get(params, fields).then(response => {
      const data = response.data.data[0]
      if (response.ok && data.success) {
        this.setState({
          deliveryNotes: data.result,
        })
      }
    })
  }

  getOptionRenderer = ({option}) => {
    const {displayInvoicedDate} = this.props

    const label = get(option, 'label')
    const value = get(option, 'value')
    const deliveryNote = get(option, 'deliveryNote')
    const invoicedDate = get(deliveryNote, 'invoicedDate', null)
    const showInvoicedDate = !isNil(invoicedDate) && !!displayInvoicedDate

    return (
        <div className={getClassName('optionContainer')}>
          {showInvoicedDate &&
              <span
                  className={getClassName('optionStatus')}
                  style={{backgroundColor: themeVars.palette.quoteStatus.invoiced}}>
                Invoiced Date: <DateComponent>{invoicedDate}</DateComponent>
              </span>
          }
          {value !== 'new' &&
              <span
                  className={getClassName('optionStatus')}
                  style={{backgroundColor: getColorForDeliveryNoteStatus(deliveryNote, false)}}>
                {getDeliveryNoteStatusName(deliveryNote, [], false)}
              </span>
          }
          <span className={getClassName('optionLabel')}>{label}</span>
        </div>
    )
  }

  getOptions = () => {
    const {allowNew} = this.props
    const {deliveryNotes} = this.state
    const options = deliveryNotes.map(getDeliveryNoteOption)
    return allowNew
        ? [
          {key: 'new', value: 'new', label: 'New'},
          ...options,
        ]
        : options
  }

  render() {
    const {...otherProps} = this.props
    return (
        <SelectField
            ref={e => this.select = e}
            placeholder={'Find a Delivery Note'}
            options={this.getOptions()}
            OptionRenderer={this.getOptionRenderer}
            {...otherProps} />
    )
  }
}

DeliveryNoteSelectField.propTypes = {
  allowNew: propTypes.bool,
  displayInvoicedDate: propTypes.bool,
  excludeLinkedToDelivery: propTypes.bool,
  excludeReturnNotes: propTypes.bool,
  orderId: propTypes.number,
  status: propTypes.string,
}

DeliveryNoteSelectField.defaultProps = {
  allowNew: false,
  displayInvoicedDate: false,
  excludeLinkedToDelivery: false,
  excludeReturnNotes: false,
}

export default DeliveryNoteSelectField
